import React from 'react';

export default function LogOut() {
  return (
    <div className="container">
      <h1>You are being Logged Out ..... Please Wait</h1>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Logout/Logout.js